/** Espacia las etiquetas sin eliminar observaciones del gráfico. */
export function spacedAxisTicks(ticks, width = 600, fontSize = 11) {
  if (!ticks.length) return [];
  const gap = 16;
  const measured = ticks.map(tick => {
    const labelWidth = String(tick.lab).length * fontSize * 0.62;
    const center = parseFloat(tick.pos) / 100 * width;
    let left = center - labelWidth / 2;
    let pos = tick.pos;
    let tx = 'translateX(-50%)';
    if (left < 0) {
      left = 0;
      pos = '0%';
      tx = 'none';
    } else if (left + labelWidth > width) {
      left = width - labelWidth;
      pos = '100%';
      tx = 'translateX(-100%)';
    }
    return { tick: { ...tick, pos, tx }, left, right: left + labelWidth };
  });
  const first = measured[0];
  const last = measured[measured.length - 1];
  const selected = [first];
  if (measured.length > 1 && last.left >= first.right + gap) {
    measured.slice(1, -1).forEach(candidate => {
      if (candidate.left >= selected[selected.length - 1].right + gap
        && candidate.right + gap <= last.left) selected.push(candidate);
    });
    selected.push(last);
  }
  return selected.map(item => item.tick);
}
